module.exports = __webpack_public_path__ + "img/Character_Yun_Jin_Thumb.6f5b2591.png";